import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../Hooks/useWorker";
import getMessageBody, {
  getMessageBodyId,
  messageBodiesDataId,
} from "../../../Actions/getMessageBody";
import MessageHeader from "./MessageHeader";
import Subject from "./Subject";
import MessageBody from "./MessageBody";
import MessageAttachments from "./MessageAttachments";

// Original (top-level) message inside a card: sender + date, the subject below
// (optional) and then the body. A toggle in the header swaps the simplified
// body for the full original one (fetched on demand).
const OriginalMessage = ({
  id,
  from_user,
  created_date_time,
  attachments,
  subject,
  body,
}) => {
  const { auth, dispatch } = useUIBp();
  const [showFull, setShowFull] = useState(false);

  const { working } = useWorker(getMessageBodyId(id));
  const loaded = useSelector(
    (state) => state.warehouse.storage[messageBodiesDataId]?.[id] !== undefined
  );

  const onToggleBody = useCallback(() => {
    if (working) return;
    if (!loaded) {
      const controller = new AbortController();
      dispatch(getMessageBody({ ...auth, messageId: id, controller }));
      setShowFull(true);
      return;
    }
    setShowFull((v) => !v);
  }, [working, loaded, dispatch, auth, id]);

  return (
    <Box>
      <MessageHeader
        {...{
          from_user,
          created_date_time,
          attachments,
          messageId: id,
          showFull,
          onToggleBody,
        }}
      />
      <Subject {...{ subject }} />
      <Box sx={{ marginTop: 1 }}>
        <MessageBody
          title={subject}
          body={body}
          messageId={id}
          showFull={showFull}
          maxHeight="50vh"
        />
      </Box>
      <MessageAttachments {...{ attachments }} />
    </Box>
  );
};

export default OriginalMessage;
